/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Target_HelpInputs */



/**
* | output |
* | --- |
* | "Draws the consumption not to exceed: the compared period, reduced by the chosen percentage." |
*
* @param {Consumption_Target_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_target_help = /** @type {((inputs?: Consumption_Target_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Target_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Draws the consumption not to exceed: the compared period, reduced by the chosen percentage.")
	return /** @type {LocalizedString} */ ("Trace la consommation à ne pas dépasser : la période comparée, réduite du pourcentage choisi.")
});